export const COURSE = 'course';
export const INSTRUCTOR = 'instructor';
export const HOME = 'home';
